<template>
  <div>
    <div
      v-for="(term, index) in formatTerms()"
      :key="index"
      :class="{ 'mt-1': index !== 0 }"
    >
      <Term :term="term" />
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { buildTermString } from "@/util.js";
import Term from "@/components/Product/Promotions/Terms/Term.vue";

export default {
  name: "TermsList",
  computed: {
    ...mapState({
      priceIncreaseEnabled: (state) => state.store.info.price_increase.enabled,
    }),
  },
  components: { Term },
  methods: {
    formatTerms() {
      const terms = [];
      for (const prop in this.promotions) {
        terms.push(
          buildTermString(
            this.byweight,
            this.promotions[prop],
            this.priceIncreaseEnabled,
            false,
          ),
        );
        this.promotions[prop].extension?.tiers.forEach((tier) => {
          terms.push(
            buildTermString(
              this.byweight,
              {
                maxoffers: tier.maxoffers,
                pricing: tier,
                type: this.promotions[prop].type,
                extension: this.promotions[prop].extension,
              },
              this.priceIncreaseEnabled,
              false,
            ),
          );
        });
      }
      return terms;
    },
  },
  props: { byweight: Boolean, promotions: Array },
};
</script>
